import { pathOr } from 'ramda';
import { createSelector } from 'reselect';
import accountSelector from './accountSelector';

export default function accountSessionBearerSelector(state: any): string {
  return String(createSelector(accountSelector, pathOr('', ['session', 'session', 'bearer']))(state));
}
